module.exports = __webpack_public_path__ + "static/media/nellie-idle.b55b3661.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/nellie-idle.png
// module id = 40
// module chunks = 0